import { useState, useEffect } from 'react';

const useThemeMode = () => {
  const getMode = () => {
    return localStorage.getItem('appMode') === 'dark' ||
      document.documentElement.classList.contains('dark')
      ? 'dark'
      : 'light';
  };

  const [mode, setMode] = useState<'dark' | 'light'>(getMode());

  useEffect(() => {
    const handleThemeChange = () => {
      setMode(getMode());
    };

    document.addEventListener('theme-reload', handleThemeChange);

    return () => {
      document.removeEventListener('theme-reload', handleThemeChange);
    };
  }, []);

  return mode;
};

export default useThemeMode;
